@if (version(); as version) {
  <div class="tt-attachment-card">
    <div>
      <mat-icon class="tt-attachment-card_left-icon" [icon]="mapMimeTypeToAttachmentType(version.contentType)" [iconSize]="24" />
    </div>
    <div class="tt-attachment-card_data">
      <div class="tt-attachment-card_data-header">
        <div class="tt-attachment-card_data-header-title">
          @if (variant() === 'editor' || variant() === 'search') {
            <span class="tt-attachment-card_data-header-title-name" [ttTooltip]="`${version.displayName}, ${version.originalName}`">
              {{ version.displayName }}
            </span>
          } @else {
            <span class="tt-attachment-card_data-header-title-name" [ttTooltip]="version.originalName">{{ version.originalName }}</span>
          }
          <div
            class="tt-attachment-card_data-header-title-status"
            [class.tt-attachment-card_data-header-title-status--active]="version.isActive">
            <!-- prettier needs to be ignored for the span causing visual bug on text -->
            <!-- prettier-ignore -->
            <span>{{ 'AssetsManagePage.EditAssetsSidebar.Active' | transloco }}</span>
          </div>
        </div>
        <div class="tt-attachment-card_data-controls">
          @if (variant() === 'editor') {
            <button class="tt-attachment-card_data-controls-item"
              ttButton
              [size]="'icon'"
              [variant]="'transparent'"
              (click)="downloaded.emit({ versionId: version.id, originalName: version.originalName })">
              <mat-icon [icon]="'download'" [iconSize]="14" />
            </button>

            <button class="tt-attachment-card_data-controls-item"
              ttButton
              [size]="'icon'"
              [variant]="'transparent'"
              (click)="deleted.emit(version.id)">
              <mat-icon [icon]="'x'" [iconSize]="14" />
            </button>
          } @else if (variant() === 'editable') {
            <button class="tt-attachment-card_data-controls-item"
              ttButton
              [size]="'icon'"
              [ttMenuPosition]="Position.TOP_CENTER"
              [ttMenuTriggerFor]="menu"
              [variant]="'transparent'">
              <mat-icon [icon]="'three-dots-horizontal'" [iconSize]="16" />
            </button>
          }
        </div>
      </div>
      @if (!isReduced()) {
        @if (version.lastUpdated) {
          <div class="tt-attachment-card_data-version-data-text">
            <span>{{ 'AssetsManagePage.EditAssetsSidebar.LastUpdated' | transloco }}: {{ version.lastUpdated | utcToLocal }}</span>
          </div>
        } @else if (version.updatedAt || version.createdAt) {
          <div class="tt-attachment-card_data-version-data-text">
            <!-- prettier needs to be ignored for the span causing visual bug on text -->
            <!-- prettier-ignore -->
            <span>{{ 'AssetsManagePage.EditAssetsSidebar.Uploaded' | transloco }}: {{ version.updatedAt || version.createdAt | utcToLocal }}</span>
          </div>
        }
        <div class="tt-attachment-card_data-version-data-text">
          <span>{{ 'AssetsManagePage.EditAssetsSidebar.FileSize' | transloco }}: {{ version.fileSizeInBytes | kilobytes }}</span>
        </div>
      }
      @if (variant() === 'search' && version.organisationDisplayName) {
        <div class="tt-attachment-card_data-organisation">
          <span class="tt-attachment-card_data-organisation-label">{{ 'Organisation' | transloco }}:</span>
          {{ version.organisationDisplayName }}
        </div>
      }
    </div>
  </div>

  <tt-menu #menu class="tt-attachment-card_data-controls-menu">
    <button
      class="tt-attachment-card_data-controls-menu-item"
      ttMenuItem
      [disabled]="version.isActive"
      (click)="setActive.emit(version.id)">
      <mat-icon [icon]="'refresh-cw'" [iconSize]="16" />
      {{ 'AssetsManagePage.EditAssetsSidebar.SetActiveVersion' | transloco }}
    </button>
    <button
      class="tt-attachment-card_data-controls-menu-item"
      ttMenuItem
      (click)="downloaded.emit({ versionId: version.id, originalName: version.originalName })">
      <mat-icon [icon]="'download'" [iconSize]="16" />
      {{ 'AssetsManagePage.EditAssetsSidebar.Download' | transloco }}
    </button>
    <button class="tt-attachment-card_data-controls-menu-item" ttMenuItem (click)="previewed.emit(version.id)">
      <mat-icon [icon]="'eye'" [iconSize]="16" />
      {{ 'AssetsManagePage.EditAssetsSidebar.Preview' | transloco }}
    </button>
    <button
      class="tt-attachment-card_data-controls-menu-item"
      ttMenuItem
      [disabled]="version.isActive"
      [ttTooltip]="version.isActive ? ('AssetsManagePage.EditAssetsSidebar.SwitchActiveVersion' | transloco) : null"
      (click)="deleted.emit(version.id)">
      <mat-icon [icon]="'trash'" [iconSize]="16" />
      {{ 'AssetsManagePage.EditAssetsSidebar.Delete' | transloco }}
    </button>
  </tt-menu>
}
